import { useState, useEffect } from 'react'

// Noted: Tempory hook before moving to `FlagSmith`
export default function usePomeloCashbackEnable(currentShopId) {
  const [isCashbackEnabled, setIsCachkbackEnabled] = useState(true)

  useEffect(() => {
    import('lib/firebase/index')
      .then(({ remoteConfig }) =>
        remoteConfig.fetchAndActivate().then(() => {
          const enabledStoreIDs = JSON.parse(
            // eslint-disable-next-line no-underscore-dangle
            remoteConfig.getValue('loyalty_enabled')._value,
          )
          setIsCachkbackEnabled(enabledStoreIDs.includes(currentShopId))
        }),
      )
      .catch(() => {
        setIsCachkbackEnabled(true)
      })
  }, [currentShopId])

  return isCashbackEnabled
}
